// extracted by mini-css-extract-plugin
export default {"center":"center__wKdjm","overflowVisible":"overflowVisible__LieCA","light":"light__YGK+t","wrapper":"wrapper__fZhi6","compact":"compact__AFcfv"};